import React from 'react';
import { Form, Badge } from 'react-bootstrap';
import axios from 'axios';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Redirect } from "react-router-dom";
import { Typeahead } from 'react-bootstrap-typeahead';
import { Spinner } from 'reactstrap';
import { Card, CardBody, Col, Fade } from 'reactstrap';

export default class Busqueda extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      posicion_tab: "1",
      idtbl_campo: 0,
      alertEnvioExitoso: false,
      nombre_llave: "",
      navigate: "",
      mostrarModalInformacion: false,
      isLoading: false,
      usuarioAutorizado: false,
      sucursales: [],
      id_sucursal: localStorage.getItem("id_sucursal"),
      nombre: '',
      apellido: '',
      cargo: '',
      empresa: '',
      ingresos: [],
      pantete: '',
      temperatura: '',
      mascarilla: '',
      visita: '',
      num: '',
      observación: '',
      fechaSalida: '',
      llaves: []
    };
    this.validaLogin = this.validaLogin.bind(this);
    this.usoMascarilla = this.usoMascarilla.bind(this);
    this.formatoh5 = this.formatoh5.bind(this);
    this.obtenerIngresosDiarios = this.obtenerIngresosDiarios.bind(this);
    this.traerSucursales = this.traerSucursales.bind(this);
    this.traerLlaves = this.traerLlaves.bind(this);
    this.handleChangePersonas = this.handleChangePersonas.bind(this);
    this.handleChangeCodigoDropBox = this.handleChangeCodigoDropBox.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.validaLogin();
    this.traerSucursales();
    this.traerLlaves();
  }


  handleChangeCodigoDropBox(event) {
    event.preventDefault();
    let valor = event.target.value
    this.setState({ id_sucursal: valor }, () => { this.traerLlaves() });


}

  traerSucursales() {
    var obj = {};
    try {
        axios.post('https://accesos.sanjoseapps.cl/api/traerSucursales.php', obj).then(response => {
            const datos = response.data;
            if (datos !== undefined) {
                this.setState({ sucursales: datos });
            };
        });

    } catch (error) {
        //console.log(error);
    }

}

traerLlaves() {
  var obj = {id_sucursal: this.state.id_sucursal};
  try {
      axios.post('https://accesos.sanjoseapps.cl/api/traerLlavesListado.php', obj).then(response => {
          const datos = response.data;
          if (datos !== undefined) {
              this.setState({ llaves: datos });
          };
      });

  } catch (error) {
      //console.log(error);
  }

}

handleChangePersonas(input, e){
 // //console.log("value", input)
  //  this.setState({ id_sucursal: valor }, () => { this.obtenerIngresosDiarios() });
}

handleChange(selectedOptions) {
  if(selectedOptions.length > 0 ){
 let valor =  selectedOptions[0];
  this.setState({nombre_llave: valor},()=> this.obtenerIngresosDiarios() );

  }
}

  validaLogin() {
    if (localStorage.getItem('idtbl_usuario') === undefined) {
      this.setState({ usuarioAutorizado: false });
    } else {
      this.setState({ usuarioAutorizado: true });
      this.obtenerIngresosDiarios();
    }
  }


  obtenerIngresosDiarios() {

    const obj = { nombre_llave: this.state.nombre_llave};
    //console.log(obj)
    try {
      axios.post('https://accesos.sanjoseapps.cl/api/traerLlaveNombre.php', obj).then(response => {
        const datos = response.data;
        //console.log(datos);
        if (datos !== undefined) {
          this.setState({ ingresos: datos })
        };
      });
    } catch (error) {
      //  //console.log(error);
    }

  }

  usoMascarilla(row) {
    let theButton;
    if (row === '0') {
      theButton = <Badge style={{ "color": "white", "padding": "0.9em 1.5em 0.9em 1.5em", "background-color": "#ce4552" }} pill variant="danger"> <h5> NO </h5> </Badge>
    } else if (row === '1') {
      theButton = <Badge style={{ "color": "white", "padding": "0.9em 1.5em 1em 1.5em", "background-color": "#95b964" }} pill variant="success"> <h5> SI </h5> </Badge>
    }
    return theButton;

  }



  formatoh5(row) {
    let columna;
    columna = <Badge> <h5> {row} </h5> </Badge>

    return columna;
  }


  render() {

    //
    var login = localStorage.getItem('idtbl_usuario');
    if (login === null || login === "undefined") {
      return <Redirect to="/" push={true} />
    } else {
      return (
        <React.Fragment>
          <Col md={12} lg={12}>
            <Card>
              {
                this.state.isLoading === true ?
                  (<section className="table table-responsive mt-md-5">
                    <div className="container table">
                      <div align="center">
                        <Spinner type="grow" color="success" /> </div>
                    </div>
                  </section>)
                  :
                  (
                    <Fade in={true} tag="h5" className="mt-3" transition={{ in: true, timeout: 750 }} >
                      <CardBody>
                        <div className="card__title">
                          <h4 className="bold-text"> Búsqueda de llave por nombre</h4>
                        </div>
                        <div className="form__form-group" style={{ "container": "wrap" }} >
                          <div className="row">
                            <h3 style={{ "margin": "2px 10px 6px 6px" }}> Llaves</h3>
                            <Form.Group controlId="dob">
                            <Typeahead
                              id="basic-typeahead-single"
                              labelKey="Persona"
                              onInputChange={(e)=> this.handleChangePersonas(e)}
                              options={this.state.llaves.map( (r) => { return ( r.nombre_llave  )}  ) }
                              placeholder="Escoger Persona..."
                              onChange={this.handleChange}
                           />
                            </Form.Group>

                            {localStorage.getItem('tipo_usuario') === "1" ? <h3 style={{ "margin": "2px 10px 6px 6px" }}> SUCURSAL</h3> : ""}
                            {localStorage.getItem('tipo_usuario') === "1" ?

                              <div>
                                <Form.Control as="select" id={"2"} onChangeCapture={this.handleChangeCodigoDropBox} value={this.state.id_sucursal} >
                                  < option key={0} value={-1}> {"Seleccione Sucursal"} </option>
                                  {this.state.sucursales.map((r) => {
                                    return (< option key={r.id_sucursal} value={r.id_sucursal}> {r.nombre} </option>)
                                  })}
                                </Form.Control>

                              </div>
                              : ""}
                          </div>
                        </div>
                        <div className="form__form-group" style={{ "container": "wrap" }} >
                          <div className="table" style={{ "margin": "auto", "fontSize": "0.7rem" }} >

                            <BootstrapTable scrollTop={'Bottom'} wrapperClasses="table-responsive" data={this.state.ingresos} search={true} searchPlaceholder={"Texto para búsqueda..."} hover pagination >
                            <TableHeaderColumn width='90' isKey dataField='id' hiddenOnInsert hidden={true} >ID</TableHeaderColumn>
                                                          <TableHeaderColumn width='150' dataFormat={this.formatoh5} dataField='nombre_llave' > <h5> LLAVE </h5> </TableHeaderColumn>
                                                           <TableHeaderColumn width='120' dataFormat={this.formatoh5} editable={false} dataSort={ true } dataField='usuario'> <h5> ENCARGADO </h5></TableHeaderColumn>

                                                            <TableHeaderColumn width='150' dataFormat={this.formatoh5} editable={false}  dataSort={ true } dataField='horaEntrega' > <h5>  HORA ENTREGA </h5> </TableHeaderColumn>
                                                            <TableHeaderColumn width='120' dataFormat={this.formatoh5} dataField='horaSalida'  dataSort={ true } > <h5> HORA DEVOLUCION </h5> </TableHeaderColumn>
                                                            <TableHeaderColumn width='120' dataFormat={this.formatoh5} editable={false} dataSort={ true } dataField='rut_usuario'> <h5> RUT ENCARGADO </h5></TableHeaderColumn>

                                                            <TableHeaderColumn width='120' dataFormat={this.formatoh5} editable={false} dataSort={ true } hidden={true} dataField='apellido'> <h5> APELLIDO</h5></TableHeaderColumn>
                                                            <TableHeaderColumn width='100' dataFormat={this.formatoh5} dataField='cargo'  dataSort={ true }  > <h5> CARGO </h5> </TableHeaderColumn>
                                                            <TableHeaderColumn width='120' dataFormat={this.formatoh5} dataField='empresa'  dataSort={ true }  > <h5> EMPRESA </h5> </TableHeaderColumn>

                            </BootstrapTable>
                          </div>
                        </div>
                      </CardBody>
                    </Fade>
                  )
              }
            </Card>
          </Col>
        </React.Fragment >
      )
    }
  }
}


